"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));
var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));
var _Clock = _interopRequireDefault(require("@react/react-spectrum/Icon/Clock"));
var _Menu = require("@react/react-spectrum/Menu");
var _Constants = require("../../constants/Constants");
var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));
var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));
require("./RemindersDropDown.scss");
var _reactIntl = require("react-intl");
var _useOmegaEvent = require("../../custom-hooks/useOmegaEvent");
var _OmegaConstants = require("../../constants/OmegaConstants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const RemindersDropDown = props => {
  const trackEvent = (0, _useOmegaEvent.useOmegaTrack)();
  const {
    isReminderActive,
    reminderTime,
    onReminderDropDownOpen,
    onReminderDropDownClose,
    onReminderDeleted,
    intl,
    onReminderSelected
  } = props;
  const {
    formatMessage
  } = intl;
  const formattedReminderTime = _PulseUtil.default.formatReminderTime(reminderTime);
  const [closeMenu, setCloseMenu] = (0, _react.useState)(false);
  const [isReminderEditInProgress, setReminderEditInProgress] = (0, _react.useState)(false);
  const showReminderEditMenu = isReminderActive && !isReminderEditInProgress;
  const selectionHandler = args => {
    switch (args) {
      case 'Remind5Min':
        onReminderSelected(_Constants.FIVE_MINUTES_IN_MILLISECONDS);
        setCloseMenu(true);
        break;
      case 'Remind15Min':
        onReminderSelected(_Constants.FIFTEEN_MINUTES_IN_MILLISECONDS);
        setCloseMenu(true);
        break;
      case 'Remind60Min':
        onReminderSelected(_Constants.SIXTY_MINUTES_IN_MILLISECONDS);
        setCloseMenu(true);
        break;
      case 'Remind24Hr':
        onReminderSelected(_Constants.TWENTY_FOUR_HOUR_IN_MILLISECONDS);
        setCloseMenu(true);
        break;
      case 'editReminder':
        if (props.notificationId) {
          trackEvent({
            element: `${_OmegaConstants.ELEMENT_TYPES.BUTTON} - reminder edit button`,
            action: _OmegaConstants.ACTION.CLICK,
            feature: _OmegaConstants.FEATURE.NOTIFICATION_PAGE,
            widget: _OmegaConstants.WIDGET_NAME.MESSAGE_FLOATING_ACTIONS,
            widgetType: _OmegaConstants.WIDGET_TYPE.MENU_ITEM,
            attributes: {
              notificationId: props.notificationId
            }
          });
        }
        setReminderEditInProgress(true);
        break;
      case 'deleteReminder':
        setCloseMenu(true);
        onReminderDeleted();
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    crossOffset: -20,
    delay: _Constants.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-actions-button"
  }, /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    crossOffset: -100,
    disabled: closeMenu,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
    },
    onHide: onReminderDropDownClose,
    onShow: onReminderDropDownOpen,
    placement: "bottom",
    trigger: "click"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "notification-snooze-button",
    icon: /*#__PURE__*/_react.default.createElement(_Clock.default, {
      size: "S"
    }),
    label: null,
    quiet: true,
    variant: "action"
  }), !showReminderEditMenu && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    className: "pulse-reminder-dropdown-menu",
    onSelect: args => selectionHandler(args)
  }, /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    value: "Remind5Min"
  }, formatMessage({
    id: 'RemindMe5Min',
    defaultMessage: 'Remind me in 5 Minutes',
    description: 'Remind me in 5 Minutes'
  })), /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    value: "Remind15Min"
  }, formatMessage({
    id: 'RemindMe15Min',
    defaultMessage: 'Remind me in 15 Minutes',
    description: 'Remind me in 15 Minutes'
  })), /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    value: "Remind60Min"
  }, formatMessage({
    id: 'RemindMe60Min',
    defaultMessage: 'Remind me in an Hour',
    description: 'Remind me in an Hour'
  })), /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    value: "Remind24Hr"
  }, formatMessage({
    id: 'RemindMeTomorrow',
    defaultMessage: 'Remind me tomorrow',
    description: 'Remind me tomorrow'
  }))), showReminderEditMenu && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    className: "pulse-reminder-dropdown-menu",
    onSelect: args => selectionHandler(args)
  }, /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    disabled: true
  }, formatMessage({
    id: 'SetReminder',
    defaultMessage: 'Reminder set for {formattedReminderTime}',
    description: 'Set Reminder'
  }, {
    formattedReminderTime
  })), /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    value: "editReminder"
  }, formatMessage({
    id: 'EditReminder',
    defaultMessage: 'Edit reminder',
    description: 'Edit reminder'
  })), /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
    value: "deleteReminder"
  }, formatMessage({
    id: 'DeleteReminder',
    defaultMessage: 'Delete reminder',
    description: 'Delete reminder'
  }))))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, isReminderActive ? formatMessage({
    id: 'SetReminder',
    defaultMessage: 'Reminder set for {formattedReminderTime}',
    description: 'Set Reminder'
  }, {
    formattedReminderTime
  }) : formatMessage({
    id: 'Snooze',
    defaultMessage: 'Snooze',
    description: 'Snooze'
  })));
};
var _default = (0, _reactIntl.injectIntl)(RemindersDropDown);
exports.default = _default;